var items = {
  "block.minecraft.air": "zrak",
  "block.minecraft.stone": "kamen",
  "block.minecraft.granite": "granit",
  "block.minecraft.polished_granite": "polirani granit",
  "block.minecraft.diorite": "diorit",
  "block.minecraft.polished_diorite": "polirani diorit",
  "block.minecraft.andesite": "andezit",
  "block.minecraft.polished_andesite": "polirani andezit",
  "block.minecraft.grass_block": "blok trave",
  "block.minecraft.dirt": "zemlja",
  "block.minecraft.coarse_dirt": "gruba zemlja",
  "block.minecraft.podzol": "podzol",
  "block.minecraft.crimson_nylium": "grimizni necelij",
  "block.minecraft.warped_nylium": "ludi necelij",
  "block.minecraft.cobblestone": "kamen",
  "block.minecraft.oak_planks": "daske od hrasta",
  "block.minecraft.spruce_planks": "daske od smreke",
  "block.minecraft.birch_planks": "daske od breze",
  "block.minecraft.jungle_planks": "daske od prašumskog drva",
  "block.minecraft.acacia_planks": "daske od akacije",
  "block.minecraft.dark_oak_planks": "daske od tamnog hrasta",
  "block.minecraft.crimson_planks": "grimizne daske",
  "block.minecraft.warped_planks": "lude daske",
  "block.minecraft.oak_sapling": "mlado drvo hrasta",
  "block.minecraft.spruce_sapling": "mlado drve smreke",
  "block.minecraft.birch_sapling": "mlado drvo breze",
  "block.minecraft.jungle_sapling": "mlado prašumsko drvo",
  "block.minecraft.acacia_sapling": "mlado drvo akacije",
  "block.minecraft.dark_oak_sapling": "mlado drvo tamnog hrasta",
  "block.minecraft.bedrock": "temelj",
  "block.minecraft.sand": "pijesak",
  "block.minecraft.red_sand": "crveni pijesak",
  "block.minecraft.gravel": "šljunak",
  "block.minecraft.gold_ore": "zlatna ruda",
  "block.minecraft.iron_ore": "željezna ruda",
  "block.minecraft.coal_ore": "ugljena ruda",
  "block.minecraft.nether_gold_ore": "ruda nether zlata",
  "block.minecraft.oak_log": "trupac hrasta",
  "block.minecraft.spruce_log": "trupac smreke",
  "block.minecraft.birch_log": "trupac breze",
  "block.minecraft.jungle_log": "trupac prašumskog drveta",
  "block.minecraft.acacia_log": "trupac akacije",
  "block.minecraft.dark_oak_log": "trupac tamnog hrasta",
  "block.minecraft.crimson_stem": "grimizni stručak",
  "block.minecraft.warped_stem": "ludi stručak",
  "block.minecraft.stripped_oak_log": "oguljeni trupac hrasta",
  "block.minecraft.stripped_spruce_log": "oguljeni trupac smreke",
  "block.minecraft.stripped_birch_log": "oguljeni trupac breze",
  "block.minecraft.stripped_jungle_log": "oguljeni trupac prašumskog drveta",
  "block.minecraft.stripped_acacia_log": "oguljeni trupac akacije",
  "block.minecraft.stripped_dark_oak_log": "oguljeni trupac tamnog hrasta",
  "block.minecraft.stripped_crimson_stem": "oguljeni grimizni stručak",
  "block.minecraft.stripped_warped_stem": "oguljeni ludi stručak",
  "block.minecraft.stripped_oak_wood": "oguljena hrastovina",
  "block.minecraft.stripped_spruce_wood": "oguljeno drvo smreke",
  "block.minecraft.stripped_birch_wood": "oguljena brezovina",
  "block.minecraft.stripped_jungle_wood": "oguljeno drvo prašumskog drva",
  "block.minecraft.stripped_acacia_wood": "oguljeno drvo akacije",
  "block.minecraft.stripped_dark_oak_wood": "oguljena tamna hrastovina",
  "block.minecraft.stripped_crimson_hyphae": "oguljene grimizne hife",
  "block.minecraft.stripped_warped_hyphae": "oguljene lude hife",
  "block.minecraft.oak_wood": "hrastovina",
  "block.minecraft.spruce_wood": "smrekovina",
  "block.minecraft.birch_wood": "brezovina",
  "block.minecraft.jungle_wood": "prašumsko drvo",
  "block.minecraft.acacia_wood": "drvo akacije",
  "block.minecraft.dark_oak_wood": "tamna hrastovina",
  "block.minecraft.crimson_hyphae": "grimizne hife",
  "block.minecraft.warped_hyphae": "lude hife",
  "block.minecraft.oak_leaves": "lišće hrasta",
  "block.minecraft.spruce_leaves": "lišće smreke",
  "block.minecraft.birch_leaves": "lišće breze",
  "block.minecraft.jungle_leaves": "lišće prašumskog drveta",
  "block.minecraft.acacia_leaves": "lišće akacije",
  "block.minecraft.dark_oak_leaves": "lišće tamnog hrasta",
  "block.minecraft.sponge": "spužva",
  "block.minecraft.wet_sponge": "mokra spužva",
  "block.minecraft.glass": "staklo",
  "block.minecraft.lapis_ore": "lazulitna ruda",
  "block.minecraft.lapis_block": "blok lazulita",
  "block.minecraft.dispenser": "streljač",
  "block.minecraft.sandstone": "pješčenjak",
  "block.minecraft.chiseled_sandstone": "isklesani pješčenjak",
  "block.minecraft.cut_sandstone": "rezani pješčenjak",
  "block.minecraft.note_block": "glazbeni blok",
  "block.minecraft.powered_rail": "pruga s pogonom",
  "block.minecraft.detector_rail": "pruga s detektorom",
  "block.minecraft.sticky_piston": "ljepljivi pokretni klip",
  "block.minecraft.cobweb": "paučina",
  "block.minecraft.grass": "trava",
  "block.minecraft.fern": "paprat",
  "block.minecraft.dead_bush": "suhi grm",
  "block.minecraft.seagrass": "morske cvjetnice",
  "block.minecraft.sea_pickle": "morski krastavac",
  "block.minecraft.piston": "pokretni klip",
  "block.minecraft.white_wool": "bijela vuna",
  "block.minecraft.orange_wool": "narančasta vuna",
  "block.minecraft.magenta_wool": "roza vuna",
  "block.minecraft.light_blue_wool": "svjetloplava vuna",
  "block.minecraft.yellow_wool": "žuta vuna",
  "block.minecraft.lime_wool": "svjetlozelena vuna",
  "block.minecraft.pink_wool": "ružičasta vuna",
  "block.minecraft.gray_wool": "siva vuna",
  "block.minecraft.light_gray_wool": "svjetlosiva vuna",
  "block.minecraft.cyan_wool": "tirkizna vuna",
  "block.minecraft.purple_wool": "ljubičasta vuna",
  "block.minecraft.blue_wool": "plava vuna",
  "block.minecraft.brown_wool": "smeđa vuna",
  "block.minecraft.green_wool": "zelena vuna",
  "block.minecraft.red_wool": "crvena vuna",
  "block.minecraft.black_wool": "crna vuna",
  "block.minecraft.dandelion": "maslačak",
  "block.minecraft.poppy": "mak",
  "block.minecraft.blue_orchid": "plava orhideja",
  "block.minecraft.allium": "ukrasni luk",
  "block.minecraft.azure_bluet": "plava maćuhica",
  "block.minecraft.red_tulip": "crveni tulipan",
  "block.minecraft.orange_tulip": "narančasti tulipan",
  "block.minecraft.white_tulip": "bijeli tulipan",
  "block.minecraft.pink_tulip": "ružičasti tulipan",
  "block.minecraft.oxeye_daisy": "tratinčica",
  "block.minecraft.cornflower": "različak",
  "block.minecraft.lily_of_the_valley": "đurđica",
  "block.minecraft.wither_rose": "wither ruža",
  "block.minecraft.brown_mushroom": "smeđa gljiva",
  "block.minecraft.red_mushroom": "crvena gljiva",
  "block.minecraft.crimson_fungus": "grimizna gljiva",
  "block.minecraft.warped_fungus": "luda gljiva",
  "block.minecraft.crimson_roots": "grimizno korijenje",
  "block.minecraft.warped_roots": "ludo korijenje",
  "block.minecraft.nether_sprouts": "nether klice",
  "block.minecraft.weeping_vines": "tužne lijane",
  "block.minecraft.twisting_vines": "uvrnute lijane",
  "block.minecraft.sugar_cane": "šećerna trska",
  "block.minecraft.kelp": "kelp",
  "block.minecraft.bamboo": "bambus",
  "block.minecraft.gold_block": "blok zlata",
  "block.minecraft.iron_block": "blok željeza",
  "block.minecraft.oak_slab": "ploča od hrasta",
  "block.minecraft.spruce_slab": "ploča od smreke",
  "block.minecraft.birch_slab": "ploča od breze",
  "block.minecraft.jungle_slab": "ploča od prašumskog drva",
  "block.minecraft.acacia_slab": "ploča od akacije",
  "block.minecraft.dark_oak_slab": "ploča od tamnog hrasta",
  "block.minecraft.crimson_slab": "grimizna ploča",
  "block.minecraft.warped_slab": "luda ploča",
  "block.minecraft.stone_slab": "ploča od kamena",
  "block.minecraft.smooth_stone_slab": "ploča od glatkog kamena",
  "block.minecraft.sandstone_slab": "ploča od pješčenjaka",
  "block.minecraft.cut_sandstone_slab": "ploča od rezanog pješčenjaka",
  "block.minecraft.petrified_oak_slab": "ploča od okamenjenog hrasta",
  "block.minecraft.cobblestone_slab": "ploča od kaldrme",
  "block.minecraft.brick_slab": "ploča od cigala",
  "block.minecraft.stone_brick_slab": "ploča od kamenih cigala",
  "block.minecraft.nether_brick_slab": "ploča od nether cigala",
  "block.minecraft.quartz_slab": "ploča od kvarca",
  "block.minecraft.red_sandstone_slab": "ploča od crvenog pješčenjaka",
  "block.minecraft.cut_red_sandstone_slab": "ploča od rezanog crvenog pješčenjaka",
  "block.minecraft.purpur_slab": "ploča od purpura",
  "block.minecraft.prismarine_slab": "ploča od prizmarina",
  "block.minecraft.prismarine_brick_slab": "ploča od prizmarinskih cigala",
  "block.minecraft.dark_prismarine_slab": "ploča od tamnog prizmarina",
  "block.minecraft.smooth_quartz": "blok od glatkog kvarca",
  "block.minecraft.smooth_red_sandstone": "obrađeni crveni pješčenjak",
  "block.minecraft.smooth_sandstone": "obrađeni pješčenjak",
  "block.minecraft.smooth_stone": "glatki kamen",
  "block.minecraft.bricks": "cigle",
  "block.minecraft.tnt": "tnt",
  "block.minecraft.bookshelf": "polica s knjigama",
  "block.minecraft.mossy_cobblestone": "obrasli blok kaldrme",
  "block.minecraft.obsidian": "opsidijan",
  "block.minecraft.torch": "baklja",
  "block.minecraft.end_rod": "end štap",
  "block.minecraft.chorus_plant": "chorus biljka",
  "block.minecraft.chorus_flower": "chorusov cvijet",
  "block.minecraft.purpur_block": "blok purpura",
  "block.minecraft.purpur_pillar": "stup purpura",
  "block.minecraft.purpur_stairs": "stube od purpura",
  "block.minecraft.spawner": "stvarač",
  "block.minecraft.oak_stairs": "stube od hrasta",
  "block.minecraft.chest": "škrinja",
  "block.minecraft.diamond_ore": "dijamantna ruda",
  "block.minecraft.diamond_block": "blok dijamanta",
  "block.minecraft.crafting_table": "radni stol",
  "block.minecraft.farmland": "obrađena zemlja",
  "block.minecraft.furnace": "peć",
  "block.minecraft.ladder": "ljestve",
  "block.minecraft.rail": "pruga",
  "block.minecraft.cobblestone_stairs": "kamene stube",
  "block.minecraft.lever": "poluga",
  "block.minecraft.stone_pressure_plate": "kamena nagazna ploča",
  "block.minecraft.oak_pressure_plate": "nagazna ploča od hrasta",
  "block.minecraft.spruce_pressure_plate": "nagazna ploča od smreke",
  "block.minecraft.birch_pressure_plate": "nagazna ploča od breze",
  "block.minecraft.jungle_pressure_plate": "nagazna ploča od prašumskog drva",
  "block.minecraft.acacia_pressure_plate": "nagazna ploča od akacije",
  "block.minecraft.dark_oak_pressure_plate": "nagazna ploča od tamnog hrasta",
  "block.minecraft.crimson_pressure_plate": "grimizna nagazna ploča",
  "block.minecraft.warped_pressure_plate": "luda nagazna ploča",
  "block.minecraft.polished_blackstone_pressure_plate": "polirana nagazna ploča od crnog kamena",
  "block.minecraft.redstone_ore": "redstone ruda",
  "block.minecraft.redstone_torch": "redstone baklja",
  "block.minecraft.snow": "snijeg",
  "block.minecraft.ice": "led",
  "block.minecraft.snow_block": "blok snijega",
  "block.minecraft.cactus": "kaktus",
  "block.minecraft.clay": "glina",
  "block.minecraft.jukebox": "glazbena kutija",
  "block.minecraft.oak_fence": "ograda od hrasta",
  "block.minecraft.spruce_fence": "ograda od smreke",
  "block.minecraft.birch_fence": "ograda od breze",
  "block.minecraft.jungle_fence": "ograda od prašumskog drva",
  "block.minecraft.acacia_fence": "ograda od akacije",
  "block.minecraft.dark_oak_fence": "ograda od tamnog hrasta",
  "block.minecraft.crimson_fence": "grimizna ograda",
  "block.minecraft.warped_fence": "luda ograda",
  "block.minecraft.pumpkin": "bundeva",
  "block.minecraft.carved_pumpkin": "urezana bundeva",
  "block.minecraft.netherrack": "netherrack",
  "block.minecraft.soul_sand": "živi pijesak",
  "block.minecraft.soul_soil": "živa zemlja",
  "block.minecraft.basalt": "bazalt",
  "block.minecraft.polished_basalt": "polirani bazalt",
  "block.minecraft.soul_torch": "živa baklja",
  "block.minecraft.glowstone": "svjetlucavi kamen",
  "block.minecraft.jack_o_lantern": "svijetleća bundeva",
  "block.minecraft.oak_trapdoor": "podna vrata od hrasta",
  "block.minecraft.spruce_trapdoor": "podna vrata od smreke",
  "block.minecraft.birch_trapdoor": "podna vrata od breze",
  "block.minecraft.jungle_trapdoor": "podna vrata od prašumskog drva",
  "block.minecraft.acacia_trapdoor": "podna vrata od akacije",
  "block.minecraft.dark_oak_trapdoor": "podna vrata od tamnog hrasta",
  "block.minecraft.crimson_trapdoor": "grimizna podna vrata",
  "block.minecraft.warped_trapdoor": "luda podna vrata",
  "block.minecraft.infested_stone": "zaraženi kamen",
  "block.minecraft.infested_cobblestone": "zaraženi blok kaldrme",
  "block.minecraft.infested_stone_bricks": "zaražene kamene cigle",
  "block.minecraft.infested_mossy_stone_bricks": "zaražene obrasle kamene cigle",
  "block.minecraft.infested_cracked_stone_bricks": "zaražene oštećene kamene cigle",
  "block.minecraft.infested_chiseled_stone_bricks": "zaražene isklesane kamene cigle",
  "block.minecraft.stone_bricks": "kamene cigle",
  "block.minecraft.mossy_stone_bricks": "obrasle kamene cigle",
  "block.minecraft.cracked_stone_bricks": "oštećene kamene cigle",
  "block.minecraft.chiseled_stone_bricks": "isklesane kamene cigle",
  "block.minecraft.brown_mushroom_block": "blok smeđe gljive",
  "block.minecraft.red_mushroom_block": "blok crvene gljive",
  "block.minecraft.mushroom_stem": "stručak gljive",
  "block.minecraft.iron_bars": "željezne šipke",
  "block.minecraft.chain": "lanac",
  "block.minecraft.glass_pane": "staklena ploča",
  "block.minecraft.melon": "lubenica",
  "block.minecraft.vine": "lijane",
  "block.minecraft.oak_fence_gate": "vrata za ogradu od hrasta",
  "block.minecraft.spruce_fence_gate": "vrata za ogradu od smreke",
  "block.minecraft.birch_fence_gate": "vrata za ogradu od breze",
  "block.minecraft.jungle_fence_gate": "vrata za ogradu od prašumskog drva",
  "block.minecraft.acacia_fence_gate": "vrata za ogradu od akacije",
  "block.minecraft.dark_oak_fence_gate": "vrata za ogradu od tamnog hrasta",
  "block.minecraft.crimson_fence_gate": "vrata za grimiznu ogradu",
  "block.minecraft.warped_fence_gate": "vrata za ludu ogradu",
  "block.minecraft.brick_stairs": "stube od cigala",
  "block.minecraft.stone_brick_stairs": "stube od kamenih cigala",
  "block.minecraft.mycelium": "micelij",
  "block.minecraft.lily_pad": "lopoč",
  "block.minecraft.nether_bricks": "nether cigle",
  "block.minecraft.cracked_nether_bricks": "oštećene nether cigle",
  "block.minecraft.chiseled_nether_bricks": "isklesane nether cigle",
  "block.minecraft.nether_brick_fence": "ograda od nether cigala",
  "block.minecraft.nether_brick_stairs": "stube od nether cigala",
  "block.minecraft.enchanting_table": "stol za čaranje",
  "block.minecraft.end_portal_frame": "okvir end portala",
  "block.minecraft.end_stone": "end kamen",
  "block.minecraft.end_stone_bricks": "end kamene cigle",
  "block.minecraft.dragon_egg": "zmajevo jaje",
  "block.minecraft.redstone_lamp": "redstone lampa",
  "block.minecraft.sandstone_stairs": "pješčane stube",
  "block.minecraft.emerald_ore": "smaragdna ruda",
  "block.minecraft.ender_chest": "ender škrinja",
  "block.minecraft.tripwire_hook": "kuka za nagaznu žicu",
  "block.minecraft.emerald_block": "blok smaragda",
  "block.minecraft.spruce_stairs": "stube od smreke",
  "block.minecraft.birch_stairs": "stube od breze",
  "block.minecraft.jungle_stairs": "stube od prašumskog drva",
  "block.minecraft.crimson_stairs": "grimizne stube",
  "block.minecraft.warped_stairs": "lude stube",
  "block.minecraft.command_block": "naredbeni blok",
  "block.minecraft.beacon": "svjetionik",
  "block.minecraft.cobblestone_wall": "zid od kaldrme",
  "block.minecraft.mossy_cobblestone_wall": "zid od obrasle kaldrme",
  "block.minecraft.brick_wall": "zid od cigala",
  "block.minecraft.prismarine_wall": "zid od prizmarina",
  "block.minecraft.red_sandstone_wall": "zid od crvenog pješčenjaka",
  "block.minecraft.mossy_stone_brick_wall": "zid od obraslih kamenih cigala",
  "block.minecraft.granite_wall": "zid od granita",
  "block.minecraft.stone_brick_wall": "zid od kamenih cigala",
  "block.minecraft.nether_brick_wall": "zid od kamenih nether cigala",
  "block.minecraft.andesite_wall": "zid od andezita",
  "block.minecraft.red_nether_brick_wall": "zid od crvenih nether cigala",
  "block.minecraft.sandstone_wall": "zid od pješčenjaka",
  "block.minecraft.end_stone_brick_wall": "zid od kamenih end cigala",
  "block.minecraft.diorite_wall": "zid od diorita",
  "block.minecraft.blackstone_wall": "zid od crnog kamena",
  "block.minecraft.polished_blackstone_wall": "zid od poliranog crnog kamena",
  "block.minecraft.polished_blackstone_brick_wall": "zid od poliranih cigala crnog kamena",
  "block.minecraft.stone_button": "kameni gumb",
  "block.minecraft.oak_button": "gumb od hrasta",
  "block.minecraft.spruce_button": "gumb od smreke",
  "block.minecraft.birch_button": "gumb od breze",
  "block.minecraft.jungle_button": "gumb od prašumskog drva",
  "block.minecraft.acacia_button": "gumb od akacije",
  "block.minecraft.dark_oak_button": "gumb od tamnog hrasta",
  "block.minecraft.crimson_button": "grimizni gumb",
  "block.minecraft.warped_button": "ludi gumb",
  "block.minecraft.polished_blackstone_button": "polirani gumb od crnog kamena",
  "block.minecraft.anvil": "nakovanj",
  "block.minecraft.chipped_anvil": "okrnjen nakovanj",
  "block.minecraft.damaged_anvil": "oštećen nakovanj",
  "block.minecraft.trapped_chest": "škrinja sa zamkom",
  "block.minecraft.light_weighted_pressure_plate": "nagazna ploča lakše osjetljivosti",
  "block.minecraft.heavy_weighted_pressure_plate": "nagazna ploča teške osjetljivosti",
  "block.minecraft.daylight_detector": "detektor dnevnog svijetla",
  "block.minecraft.redstone_block": "blok redstona",
  "block.minecraft.nether_quartz_ore": "nether kvarcna ruda",
  "block.minecraft.hopper": "lijevak",
  "block.minecraft.chiseled_quartz_block": "isklesani blok kvarca",
  "block.minecraft.quartz_block": "blok kvarca",
  "block.minecraft.quartz_bricks": "kvarcne cigle",
  "block.minecraft.quartz_pillar": "stup od kvarca",
  "block.minecraft.quartz_stairs": "stube od kvarca",
  "block.minecraft.activator_rail": "pruga s aktivatorom",
  "block.minecraft.dropper": "izbacivač",
  "block.minecraft.white_terracotta": "bijela terakota",
  "block.minecraft.orange_terracotta": "narančasta terakota",
  "block.minecraft.magenta_terracotta": "roza terakota",
  "block.minecraft.light_blue_terracotta": "svjetloplava terakota",
  "block.minecraft.yellow_terracotta": "žuta terakota",
  "block.minecraft.lime_terracotta": "svjetlozelena terakota",
  "block.minecraft.pink_terracotta": "ružičasta terakota",
  "block.minecraft.gray_terracotta": "siva terakota",
  "block.minecraft.light_gray_terracotta": "svjetlosiva terakota",
  "block.minecraft.cyan_terracotta": "tirkizna terakota",
  "block.minecraft.purple_terracotta": "ljubičasta terakota",
  "block.minecraft.blue_terracotta": "plava terakota",
  "block.minecraft.brown_terracotta": "smeđa terakota",
  "block.minecraft.green_terracotta": "zelena terakota",
  "block.minecraft.red_terracotta": "crvena terakota",
  "block.minecraft.black_terracotta": "crna terakota",
  "block.minecraft.barrier": "barijera",
  "block.minecraft.iron_trapdoor": "željezna podna vrata",
  "block.minecraft.hay_block": "bala sijena",
  "block.minecraft.white_carpet": "bijeli tepih",
  "block.minecraft.orange_carpet": "narančasti tepih",
  "block.minecraft.magenta_carpet": "roza tepih",
  "block.minecraft.light_blue_carpet": "svjetloplavi tepih",
  "block.minecraft.yellow_carpet": "žuti tepih",
  "block.minecraft.lime_carpet": "svjetlozeleni tepih",
  "block.minecraft.pink_carpet": "ružičasti tepih",
  "block.minecraft.gray_carpet": "sivi tepih",
  "block.minecraft.light_gray_carpet": "svjetlosivi tepih",
  "block.minecraft.cyan_carpet": "tirkizni tepih",
  "block.minecraft.purple_carpet": "ljubičasti tepih",
  "block.minecraft.blue_carpet": "plavi tepih",
  "block.minecraft.brown_carpet": "smeđi tepih",
  "block.minecraft.green_carpet": "zeleni tepih",
  "block.minecraft.red_carpet": "crveni tepih",
  "block.minecraft.black_carpet": "crni tepih",
  "block.minecraft.terracotta": "terakota",
  "block.minecraft.coal_block": "blok ugljena",
  "block.minecraft.packed_ice": "tvrdi led",
  "block.minecraft.acacia_stairs": "stube od akacije",
  "block.minecraft.dark_oak_stairs": "stube od tamnog hrasta",
  "block.minecraft.slime_block": "ljigavi blok",
  "block.minecraft.grass_path": "travnati put",
  "block.minecraft.sunflower": "suncokret",
  "block.minecraft.lilac": "jorgovan",
  "block.minecraft.rose_bush": "grm ruža",
  "block.minecraft.peony": "božur",
  "block.minecraft.tall_grass": "visoka trava",
  "block.minecraft.large_fern": "velika paprat",
  "block.minecraft.white_stained_glass": "bijelo staklo",
  "block.minecraft.orange_stained_glass": "narančasto staklo",
  "block.minecraft.magenta_stained_glass": "roza staklo",
  "block.minecraft.light_blue_stained_glass": "svjetloplavo staklo",
  "block.minecraft.yellow_stained_glass": "žuto staklo",
  "block.minecraft.lime_stained_glass": "svjetlozeleno staklo",
  "block.minecraft.pink_stained_glass": "ružičasto staklo",
  "block.minecraft.gray_stained_glass": "sivo staklo",
  "block.minecraft.light_gray_stained_glass": "svjetlosivo staklo",
  "block.minecraft.cyan_stained_glass": "tirkizno staklo",
  "block.minecraft.purple_stained_glass": "ljubičasto staklo",
  "block.minecraft.blue_stained_glass": "plavo staklo",
  "block.minecraft.brown_stained_glass": "smeđe staklo",
  "block.minecraft.green_stained_glass": "zeleno staklo",
  "block.minecraft.red_stained_glass": "crveno staklo",
  "block.minecraft.black_stained_glass": "crno staklo",
  "block.minecraft.white_stained_glass_pane": "bijela staklena ploča",
  "block.minecraft.orange_stained_glass_pane": "narančasta staklena ploča",
  "block.minecraft.magenta_stained_glass_pane": "roza staklena ploča",
  "block.minecraft.light_blue_stained_glass_pane": "svjetloplava staklena ploča",
  "block.minecraft.yellow_stained_glass_pane": "žuta staklena ploča",
  "block.minecraft.lime_stained_glass_pane": "svjetlozelena staklena ploča",
  "block.minecraft.pink_stained_glass_pane": "ružičasta staklena ploča",
  "block.minecraft.gray_stained_glass_pane": "siva staklena ploča",
  "block.minecraft.light_gray_stained_glass_pane": "svjetlosiva staklena ploča",
  "block.minecraft.cyan_stained_glass_pane": "tirkizna staklena ploča",
  "block.minecraft.purple_stained_glass_pane": "ljubičasta staklena ploča",
  "block.minecraft.blue_stained_glass_pane": "plava staklena ploča",
  "block.minecraft.brown_stained_glass_pane": "smeđa staklena ploča",
  "block.minecraft.green_stained_glass_pane": "zelena staklena ploča",
  "block.minecraft.red_stained_glass_pane": "crvena staklena ploča",
  "block.minecraft.black_stained_glass_pane": "crna staklena ploča",
  "block.minecraft.prismarine": "prizmarin",
  "block.minecraft.prismarine_bricks": "cigle prizmarina",
  "block.minecraft.dark_prismarine": "tamni prizmarin",
  "block.minecraft.prismarine_stairs": "stube od prizmarina",
  "block.minecraft.prismarine_brick_stairs": "stube od prizmarinskih cigala",
  "block.minecraft.dark_prismarine_stairs": "stube od tamnog prizmarina",
  "block.minecraft.sea_lantern": "podvodna svjetiljka",
  "block.minecraft.red_sandstone": "crveni pješčenjak",
  "block.minecraft.chiseled_red_sandstone": "isklesani crveni pješčenjak",
  "block.minecraft.cut_red_sandstone": "rezani crveni pješčenjak",
  "block.minecraft.red_sandstone_stairs": "stube od crvenog pješčenjaka",
  "block.minecraft.repeating_command_block": "ponavljajući naredbeni blok",
  "block.minecraft.chain_command_block": "lančani naredbeni blok",
  "block.minecraft.magma_block": "blok magme",
  "block.minecraft.nether_wart_block": "blok nether lišaja",
  "block.minecraft.warped_wart_block": "blok ludog lišaja",
  "block.minecraft.red_nether_bricks": "crvene nether cigle",
  "block.minecraft.bone_block": "koštani blok",
  "block.minecraft.structure_void": "strukturna praznina",
  "block.minecraft.observer": "promatrač",
  "block.minecraft.shulker_box": "shulkerova kutija",
  "block.minecraft.white_shulker_box": "bijela shulker kutija",
  "block.minecraft.orange_shulker_box": "narančasta shulker kutija",
  "block.minecraft.magenta_shulker_box": "roza shulker kutija",
  "block.minecraft.light_blue_shulker_box": "svjetloplava shulker kutija",
  "block.minecraft.yellow_shulker_box": "žuta shulker kutija",
  "block.minecraft.lime_shulker_box": "svjetlozelena shulker kutija",
  "block.minecraft.pink_shulker_box": "ružičasta shulker kutija",
  "block.minecraft.gray_shulker_box": "siva shulker kutija",
  "block.minecraft.light_gray_shulker_box": "svjetlosiva shulker kutija",
  "block.minecraft.cyan_shulker_box": "tirkizna shulker kutija",
  "block.minecraft.purple_shulker_box": "ljubičasta shulker kutija",
  "block.minecraft.blue_shulker_box": "plava shulker kutija",
  "block.minecraft.brown_shulker_box": "smeđa shulker kutija",
  "block.minecraft.green_shulker_box": "zelena shulker kutija",
  "block.minecraft.red_shulker_box": "crvena shulker kutija",
  "block.minecraft.black_shulker_box": "crna shulker kutija",
  "block.minecraft.white_glazed_terracotta": "bijela glazirana terakota",
  "block.minecraft.orange_glazed_terracotta": "narančasta glazirana terakota",
  "block.minecraft.magenta_glazed_terracotta": "roza glazirana terakota",
  "block.minecraft.light_blue_glazed_terracotta": "svjetloplava glazirana terakota",
  "block.minecraft.yellow_glazed_terracotta": "žuta glazirana terakota",
  "block.minecraft.lime_glazed_terracotta": "svjetlozelena glazirana terakota",
  "block.minecraft.pink_glazed_terracotta": "ružičasta glazirana terakota",
  "block.minecraft.gray_glazed_terracotta": "siva glazirana terakota",
  "block.minecraft.light_gray_glazed_terracotta": "svjetlosiva glazirana terakota",
  "block.minecraft.cyan_glazed_terracotta": "tirkizna glazirana terakota",
  "block.minecraft.purple_glazed_terracotta": "ljubičasta glazirana terakota",
  "block.minecraft.blue_glazed_terracotta": "plava glazirana terakota",
  "block.minecraft.brown_glazed_terracotta": "smeđa glazirana terakota",
  "block.minecraft.green_glazed_terracotta": "zelena glazirana terakota",
  "block.minecraft.red_glazed_terracotta": "crvena glazirana terakota",
  "block.minecraft.black_glazed_terracotta": "crna glazirana terakota",
  "block.minecraft.white_concrete": "bijeli beton",
  "block.minecraft.orange_concrete": "narančasti beton",
  "block.minecraft.magenta_concrete": "roza beton",
  "block.minecraft.light_blue_concrete": "svjetloplavi beton",
  "block.minecraft.yellow_concrete": "žuti beton",
  "block.minecraft.lime_concrete": "svjetlozeleni beton",
  "block.minecraft.pink_concrete": "ružičasti beton",
  "block.minecraft.gray_concrete": "sivi beton",
  "block.minecraft.light_gray_concrete": "svjetlosivi beton",
  "block.minecraft.cyan_concrete": "tirkizni beton",
  "block.minecraft.purple_concrete": "ljubičasti beton",
  "block.minecraft.blue_concrete": "plavi beton",
  "block.minecraft.brown_concrete": "smeđi beton",
  "block.minecraft.green_concrete": "zeleni beton",
  "block.minecraft.red_concrete": "crveni beton",
  "block.minecraft.black_concrete": "crni beton",
  "block.minecraft.white_concrete_powder": "bijeli prah betona",
  "block.minecraft.orange_concrete_powder": "narančasti prah betona",
  "block.minecraft.magenta_concrete_powder": "roza prah betona",
  "block.minecraft.light_blue_concrete_powder": "svjetloplavi prah betona",
  "block.minecraft.yellow_concrete_powder": "žuti prah betona",
  "block.minecraft.lime_concrete_powder": "svjetlozeleni prah betona",
  "block.minecraft.pink_concrete_powder": "ružičasti prah betona",
  "block.minecraft.gray_concrete_powder": "sivi prah betona",
  "block.minecraft.light_gray_concrete_powder": "svjetlosivi prah betona",
  "block.minecraft.cyan_concrete_powder": "tirkizni prah betona",
  "block.minecraft.purple_concrete_powder": "ljubičasti prah betona",
  "block.minecraft.blue_concrete_powder": "plavi prah betona",
  "block.minecraft.brown_concrete_powder": "smeđi prah betona",
  "block.minecraft.green_concrete_powder": "zeleni prah betona",
  "block.minecraft.red_concrete_powder": "crveni prah betona",
  "block.minecraft.black_concrete_powder": "crni prah betona",
  "block.minecraft.turtle_egg": "kornjačino jaje",
  "block.minecraft.dead_tube_coral_block": "blok mrtvog cjevastog koralja",
  "block.minecraft.dead_brain_coral_block": "blok mrtvog mozgovog koralja",
  "block.minecraft.dead_bubble_coral_block": "blok mrtvog mjehuričastog koralja",
  "block.minecraft.dead_fire_coral_block": "blok mrtvog vatrenog koralja",
  "block.minecraft.dead_horn_coral_block": "blok mrtvog rogastog koralja",
  "block.minecraft.tube_coral_block": "blok cjevastog koralja",
  "block.minecraft.brain_coral_block": "blok mozgovog koralja",
  "block.minecraft.bubble_coral_block": "blok mjehuričastog koralja",
  "block.minecraft.fire_coral_block": "blok vatrenog koralja",
  "block.minecraft.horn_coral_block": "blok rogastog koralja",
  "block.minecraft.tube_coral": "cjevasti koralj",
  "block.minecraft.brain_coral": "mozgov koralj",
  "block.minecraft.bubble_coral": "mjehuričasti koralj",
  "block.minecraft.fire_coral": "vatreni koralj",
  "block.minecraft.horn_coral": "rogasti koralj",
  "block.minecraft.dead_brain_coral": "mrtvi mozgov koralj",
  "block.minecraft.dead_bubble_coral": "mrtvi mjehuričasti koralj",
  "block.minecraft.dead_fire_coral": "mrtvi vatreni koralj",
  "block.minecraft.dead_horn_coral": "mrtvi rogasti koralj",
  "block.minecraft.dead_tube_coral": "mrtvi cjevasti koralj",
  "block.minecraft.tube_coral_fan": "cjevasti kožasti koralj",
  "block.minecraft.brain_coral_fan": "mozgov kožasti koralj",
  "block.minecraft.bubble_coral_fan": "mjehuričasti kožasti koralj",
  "block.minecraft.fire_coral_fan": "vatreni kožasti koralj",
  "block.minecraft.horn_coral_fan": "rogasti kožasti koralj",
  "block.minecraft.dead_tube_coral_fan": "mrtvi cjevasti kožasti koralj",
  "block.minecraft.dead_brain_coral_fan": "mrtvi mozgov kožasti koralj",
  "block.minecraft.dead_bubble_coral_fan": "mrtvi mjehuričasti kožasti koralj",
  "block.minecraft.dead_fire_coral_fan": "mrtvi vatreni kožasti koralj",
  "block.minecraft.dead_horn_coral_fan": "mrtvi rogasti kožasti koralj",
  "block.minecraft.blue_ice": "plavi led",
  "block.minecraft.conduit": "konduktor",
  "block.minecraft.polished_granite_stairs": "stube od poliranog granita",
  "block.minecraft.smooth_red_sandstone_stairs": "stube od glatkog crvenog pješčenjaka",
  "block.minecraft.mossy_stone_brick_stairs": "stube od obraslih kamenih cigala",
  "block.minecraft.polished_diorite_stairs": "stube od poliranog diorita",
  "block.minecraft.mossy_cobblestone_stairs": "stube od obrasle kaldrme",
  "block.minecraft.end_stone_brick_stairs": "stube od kamenih end cigala",
  "block.minecraft.stone_stairs": "stube od kamena",
  "block.minecraft.smooth_sandstone_stairs": "stube od glatkog pješčenjaka",
  "block.minecraft.smooth_quartz_stairs": "stube od glatkog kvarca",
  "block.minecraft.granite_stairs": "stube od granita",
  "block.minecraft.andesite_stairs": "stube od andezita",
  "block.minecraft.red_nether_brick_stairs": "stube od crvenih nether cigala",
  "block.minecraft.polished_andesite_stairs": "stube od poliranog andezita",
  "block.minecraft.diorite_stairs": "stube od diorita",
  "block.minecraft.polished_granite_slab": "ploča od poliranog granita",
  "block.minecraft.smooth_red_sandstone_slab": "ploča od glatkog crvenog pješčenjaka",
  "block.minecraft.mossy_stone_brick_slab": "ploča od obraslih kamenih cigala",
  "block.minecraft.polished_diorite_slab": "ploča od poliranog diorita",
  "block.minecraft.mossy_cobblestone_slab": "ploča od obrasle kaldrme",
  "block.minecraft.end_stone_brick_slab": "ploča od kamenih end cigala",
  "block.minecraft.smooth_sandstone_slab": "ploča od glatkog pješčenjaka",
  "block.minecraft.smooth_quartz_slab": "ploča od glatkog kvarca",
  "block.minecraft.granite_slab": "ploča od granita",
  "block.minecraft.andesite_slab": "ploča od andezita",
  "block.minecraft.red_nether_brick_slab": "ploča od crvenih nether cigala",
  "block.minecraft.polished_andesite_slab": "ploča od poliranog andezita",
  "block.minecraft.diorite_slab": "ploča od diorita",
  "block.minecraft.scaffolding": "skela",
  "block.minecraft.iron_door": "željezna vrata",
  "block.minecraft.oak_door": "vrata hrasta",
  "block.minecraft.spruce_door": "vrata smreke",
  "block.minecraft.birch_door": "vrata breze",
  "block.minecraft.jungle_door": "vrata prašumskog drva",
  "block.minecraft.acacia_door": "vrata akacije",
  "block.minecraft.dark_oak_door": "vrata tamnog hrasta",
  "block.minecraft.crimson_door": "grimizna vrata",
  "block.minecraft.warped_door": "luda vrata",
  "block.minecraft.repeater": "redstone repetitor",
  "block.minecraft.comparator": "redstone komparator",
  "block.minecraft.structure_block": "strukturni blok",
  "block.minecraft.jigsaw": "blok slagalice",
  "item.minecraft.turtle_helmet": "kornjačin oklop□□kada je na glavi:□+2 oklop",
  "item.minecraft.scute": "ljuska",
  "item.minecraft.iron_shovel": "željezna lopata□□kada je u glavnoj ruci:□+3.5 jačina napada□-3 brzina napada",
  "item.minecraft.iron_pickaxe": "željezni kramp□□kada je u glavnoj ruci:□+3 jačina napada□-2.8 brzina napada",
  "item.minecraft.iron_axe": "željezna sjekira□□kada je u glavnoj ruci:□+8 jačina napada□-3.1 brzina napada",
  "item.minecraft.flint_and_steel": "kremen i čelik",
  "item.minecraft.apple": "jabuka",
  "item.minecraft.bow": "luk",
  "item.minecraft.arrow": "strijela",
  "item.minecraft.coal": "ugljen",
  "item.minecraft.charcoal": "drveni ugljen",
  "item.minecraft.diamond": "dijamant",
  "item.minecraft.iron_ingot": "željezna poluga",
  "item.minecraft.gold_ingot": "zlatna poluga",
  "item.minecraft.netherite_ingot": "netheritska poluga",
  "item.minecraft.netherite_scrap": "komadić netherita",
  "item.minecraft.iron_sword": "željezni mač□□kada je u glavnoj ruci:□+5 jačina napada□-2.4 brzina napada",
  "item.minecraft.wooden_sword": "drveni mač□□kada je u glavnoj ruci:□+3 jačina napada□-2.4 brzina napada",
  "item.minecraft.wooden_shovel": "drvena lopata□□kada je u glavnoj ruci:□+1.5 jačina napada□-3 brzina napada",
  "item.minecraft.wooden_pickaxe": "drveni kramp□□kada je u glavnoj ruci:□+1 jačina napada□-2.8 brzina napada",
  "item.minecraft.wooden_axe": "drvena sjekira□□kada je u glavnoj ruci:□+6 jačina napada□-3.2 brzina napada",
  "item.minecraft.stone_sword": "kameni mač□□kada je u glavnoj ruci:□+4 jačina napada□-2.4 brzina napada",
  "item.minecraft.stone_shovel": "kamena lopata□□kada je u glavnoj ruci:□+2.5 jačina napada□-3 brzina napada",
  "item.minecraft.stone_pickaxe": "kameni kramp□□kada je u glavnoj ruci:□+2 jačina napada□-2.8 brzina napada",
  "item.minecraft.stone_axe": "kamena sjekira□□kada je u glavnoj ruci:□+8 jačina napada□-3.2 brzina napada",
  "item.minecraft.diamond_sword": "dijamantni mač□□kada je u glavnoj ruci:□+6 jačina napada□-2.4 brzina napada",
  "item.minecraft.diamond_shovel": "dijamantna lopata□□kada je u glavnoj ruci:□+4.5 jačina napada□-3 brzina napada",
  "item.minecraft.diamond_pickaxe": "dijamantni kramp□□kada je u glavnoj ruci:□+4 jačina napada□-2.8 brzina napada",
  "item.minecraft.diamond_axe": "dijamantna sjekira□□kada je u glavnoj ruci:□+8 jačina napada□-3 brzina napada",
  "item.minecraft.stick": "štap",
  "item.minecraft.bowl": "zdjela",
  "item.minecraft.mushroom_stew": "gulaš od gljiva",
  "item.minecraft.golden_sword": "zlatni mač□□kada je u glavnoj ruci:□+3 jačina napada□-2.4 brzina napada",
  "item.minecraft.golden_shovel": "zlatna lopata□□kada je u glavnoj ruci:□+1.5 jačina napada□-3 brzina napada",
  "item.minecraft.golden_pickaxe": "zlatni kramp□□kada je u glavnoj ruci:□+1 jačina napada□-2.8 brzina napada",
  "item.minecraft.golden_axe": "zlatna sjekira□□kada je u glavnoj ruci:□+6 jačina napada□-3 brzina napada",
  "item.minecraft.netherite_sword": "netheritski mač□□kada je u glavnoj ruci:□+7 jačina napada□-2.4 brzina napada",
  "item.minecraft.netherite_shovel": "netheritska lopata□□kada je u glavnoj ruci:□+5.5 jačina napada□-3 brzina napada",
  "item.minecraft.netherite_pickaxe": "netheritski kramp□□kada je u glavnoj ruci:□+5 jačina napada□-2.8 brzina napada",
  "item.minecraft.netherite_axe": "netheritska sjekira□□kada je u glavnoj ruci:□+9 jačina napada□-3 brzina napada",
  "item.minecraft.string": "nit",
  "item.minecraft.feather": "pero",
  "item.minecraft.gunpowder": "barut",
  "item.minecraft.wooden_hoe": "drvena motika□□kada je u glavnoj ruci:□-3 brzina napada",
  "item.minecraft.stone_hoe": "kamena motika□□kada je u glavnoj ruci:□-2 brzina napada",
  "item.minecraft.iron_hoe": "željezna motika□□kada je u glavnoj ruci:□-1 brzina napada",
  "item.minecraft.diamond_hoe": "dijamantna motika□□kada je u glavnoj ruci:",
  "item.minecraft.golden_hoe": "zlatna motika□□kada je u glavnoj ruci:□-3 brzina napada",
  "item.minecraft.netherite_hoe": "netheritska motika□□kada je u glavnoj ruci:",
  "item.minecraft.wheat_seeds": "sjemenke pšenice",
  "item.minecraft.wheat": "pšenica",
  "item.minecraft.bread": "kruh",
  "item.minecraft.leather_helmet": "kožna kapa□□kada je na glavi:□+1 oklop",
  "item.minecraft.leather_chestplate": "kožna tunika□□kada je na tijelu:□+3 oklop",
  "item.minecraft.leather_leggings": "kožne hlače□□kada je na nogama:□+2 oklop",
  "item.minecraft.leather_boots": "kožne čizme□□kada je na stopalima:□+1 oklop",
  "item.minecraft.chainmail_helmet": "lančani šljem□□kada je na glavi:□+2 oklop",
  "item.minecraft.chainmail_chestplate": "lančani prsni oklop□□kada je na tijelu:□+5 oklop",
  "item.minecraft.chainmail_leggings": "lančane gamaše□□kada je na nogama:□+4 oklop",
  "item.minecraft.chainmail_boots": "lančane čizme□□kada je na stopalima:□+1 oklop",
  "item.minecraft.iron_helmet": "željezni šljem□□kada je na glavi:□+2 oklop",
  "item.minecraft.iron_chestplate": "željezni prsni oklop□□kada je na tijelu:□+6 oklop",
  "item.minecraft.iron_leggings": "željezne gamaše□□kada je na nogama:□+5 oklop",
  "item.minecraft.iron_boots": "željezne čizme□□kada je na stopalima:□+2 oklop",
  "item.minecraft.diamond_helmet": "dijamantni šljem□□kada je na glavi:□+3 oklop□+2 izdržljivost oklopa",
  "item.minecraft.diamond_chestplate": "dijamantni prsni oklop□□kada je na tijelu:□+8 oklop□+2 izdržljivost oklopa",
  "item.minecraft.diamond_leggings": "dijamantne gamaše□□kada je na nogama:□+6 oklop□+2 izdržljivost oklopa",
  "item.minecraft.diamond_boots": "dijamantne čizme□□kada je na stopalima:□+3 oklop□+2 izdržljivost oklopa",
  "item.minecraft.golden_helmet": "zlatni šljem□□kada je na glavi:□+2 oklop",
  "item.minecraft.golden_chestplate": "zlatni prsni oklop□□kada je na tijelu:□+5 oklop",
  "item.minecraft.golden_leggings": "zlatne gamaše□□kada je na nogama:□+3 oklop",
  "item.minecraft.golden_boots": "zlatne čizme□□kada je na stopalima:□+1 oklop",
  "item.minecraft.netherite_helmet": "netheritska kaciga□□kada je na glavi:□+3 oklop□+3 izdržljivost oklopa□+1 otpor na snažan udarac",
  "item.minecraft.netherite_chestplate": "netheritski prsni oklop□□kada je na tijelu:□+8 oklop□+3 izdržljivost oklopa□+1 otpor na snažan udarac",
  "item.minecraft.netherite_leggings": "netheritske gamaše□□kada je na nogama:□+6 oklop□+3 izdržljivost oklopa□+1 otpor na snažan udarac",
  "item.minecraft.netherite_boots": "netheritske čizme□□kada je na stopalima:□+3 oklop□+3 izdržljivost oklopa□+1 otpor na snažan udarac",
  "item.minecraft.flint": "kremen",
  "item.minecraft.porkchop": "sirova svinjetina",
  "item.minecraft.cooked_porkchop": "pečena svinjetina",
  "item.minecraft.painting": "slika",
  "item.minecraft.golden_apple": "zlatna jabuka",
  "item.minecraft.enchanted_golden_apple": "začarana zlatna jabuka",
  "block.minecraft.oak_sign": "znak od hrasta",
  "block.minecraft.spruce_sign": "znak od smreke",
  "block.minecraft.birch_sign": "znak od breze",
  "block.minecraft.jungle_sign": "znak od prašumskog drva",
  "block.minecraft.acacia_sign": "znak od akacije",
  "block.minecraft.dark_oak_sign": "znak od tamnog hrasta",
  "block.minecraft.crimson_sign": "grimizni znak",
  "block.minecraft.warped_sign": "ludi znak",
  "item.minecraft.bucket": "kanta",
  "item.minecraft.water_bucket": "kanta s vodom",
  "item.minecraft.lava_bucket": "kanta s lavom",
  "item.minecraft.minecart": "vagon",
  "item.minecraft.saddle": "sedlo",
  "item.minecraft.redstone": "redstone prašina",
  "item.minecraft.snowball": "snježna gruda",
  "item.minecraft.oak_boat": "čamac od hrasta",
  "item.minecraft.leather": "koža",
  "item.minecraft.milk_bucket": "kanta s mlijekom",
  "item.minecraft.pufferfish_bucket": "kanta s napuhačom",
  "item.minecraft.salmon_bucket": "kanta s lososom",
  "item.minecraft.cod_bucket": "kanta s bakalarom",
  "item.minecraft.tropical_fish_bucket": "kanta s tropskom ribom",
  "item.minecraft.brick": "cigla",
  "item.minecraft.clay_ball": "glinena kuglica",
  "block.minecraft.dried_kelp_block": "blok osušenog kelpa",
  "item.minecraft.paper": "papir",
  "item.minecraft.book": "knjiga",
  "item.minecraft.slime_ball": "ljigava kuglica",
  "item.minecraft.chest_minecart": "vagon sa škrinjom",
  "item.minecraft.furnace_minecart": "vagon s peći",
  "item.minecraft.egg": "jaje",
  "item.minecraft.compass": "kompas",
  "item.minecraft.fishing_rod": "štap za pecanje",
  "item.minecraft.clock": "sat",
  "item.minecraft.glowstone_dust": "svjetlucava prašina",
  "item.minecraft.cod": "sirovi bakalar",
  "item.minecraft.salmon": "sirovi losos",
  "item.minecraft.tropical_fish": "tropska riba",
  "item.minecraft.pufferfish": "napuhača",
  "item.minecraft.cooked_cod": "kuhani bakalar",
  "item.minecraft.cooked_salmon": "kuhani losos",
  "item.minecraft.ink_sac": "crna tinta",
  "item.minecraft.red_dye": "crvena boja",
  "item.minecraft.green_dye": "zelena boja",
  "item.minecraft.cocoa_beans": "sjemenke kakaa",
  "item.minecraft.lapis_lazuli": "lazulit",
  "item.minecraft.purple_dye": "ljubičasta boja",
  "item.minecraft.cyan_dye": "tirkizna boja",
  "item.minecraft.light_gray_dye": "svjetlosiva boja",
  "item.minecraft.gray_dye": "siva boja",
  "item.minecraft.pink_dye": "ružičasta boja",
  "item.minecraft.lime_dye": "svjetlozelena boja",
  "item.minecraft.yellow_dye": "žuta boja",
  "item.minecraft.light_blue_dye": "svjetloplava boja",
  "item.minecraft.magenta_dye": "roza boja",
  "item.minecraft.orange_dye": "narančasta boja",
  "item.minecraft.bone_meal": "koštano brašno",
  "item.minecraft.blue_dye": "plava boja",
  "item.minecraft.brown_dye": "smeđa boja",
  "item.minecraft.black_dye": "crna boja",
  "item.minecraft.white_dye": "bijela boja",
  "item.minecraft.bone": "kost",
  "item.minecraft.sugar": "šećer",
  "block.minecraft.cake": "torta",
  "block.minecraft.white_bed": "bijeli krevet",
  "block.minecraft.orange_bed": "narančasti krevet",
  "block.minecraft.magenta_bed": "roza krevet",
  "block.minecraft.light_blue_bed": "svjetloplavi krevet",
  "block.minecraft.yellow_bed": "žuti krevet",
  "block.minecraft.lime_bed": "svjetlozeleni krevet",
  "block.minecraft.pink_bed": "ružičasti krevet",
  "block.minecraft.gray_bed": "sivi krevet",
  "block.minecraft.light_gray_bed": "svjetlosivi krevet",
  "block.minecraft.cyan_bed": "tirkizni krevet",
  "block.minecraft.purple_bed": "ljubičasti krevet",
  "block.minecraft.blue_bed": "plavi krevet",
  "block.minecraft.brown_bed": "smeđi krevet",
  "block.minecraft.green_bed": "zeleni krevet",
  "block.minecraft.red_bed": "crveni krevet",
  "block.minecraft.black_bed": "crni krevet",
  "item.minecraft.cookie": "kolačić",
  "item.minecraft.filled_map": "karta□#0",
  "item.minecraft.shears": "škare",
  "item.minecraft.melon_slice": "kriška lubenice",
  "item.minecraft.dried_kelp": "osušeni kelp",
  "item.minecraft.pumpkin_seeds": "sjemenke bundeve",
  "item.minecraft.melon_seeds": "sjemenke lubenice",
  "item.minecraft.beef": "sirova govedina",
  "item.minecraft.cooked_beef": "odrezak",
  "item.minecraft.chicken": "sirova piletina",
  "item.minecraft.cooked_chicken": "pečena piletina",
  "item.minecraft.rotten_flesh": "trulo meso",
  "item.minecraft.ender_pearl": "ender biser",
  "item.minecraft.blaze_rod": "bljeskov štap",
  "item.minecraft.ghast_tear": "suza ghasta",
  "item.minecraft.gold_nugget": "grumen zlata",
  "item.minecraft.nether_wart": "nether lišaj",
  "item.minecraft.potion": "nestvoriv napitak□bez efekata",
  "item.minecraft.glass_bottle": "staklena bočica",
  "item.minecraft.spider_eye": "paukovo oko",
  "item.minecraft.fermented_spider_eye": "fermentirano paukovo oko",
  "item.minecraft.blaze_powder": "bljeskov prah",
  "item.minecraft.magma_cream": "magmasta kuglica",
  "block.minecraft.brewing_stand": "postolje za napitke",
  "block.minecraft.cauldron": "kotao",
  "item.minecraft.ender_eye": "oko endera",
  "item.minecraft.glistering_melon_slice": "sjajna kriška lubenice",
  "item.minecraft.bat_spawn_egg": "jaje za stvaranje šišmiša",
  "item.minecraft.bee_spawn_egg": "jaje za stvaranje pčele",
  "item.minecraft.blaze_spawn_egg": "jaje za stvaranje bljeska",
  "item.minecraft.cat_spawn_egg": "jaje za stvaranje mačke",
  "item.minecraft.cave_spider_spawn_egg": "jaje za stvaranje špiljskog pauka",
  "item.minecraft.chicken_spawn_egg": "jaje za stvaranje kokoši",
  "item.minecraft.cod_spawn_egg": "jaje za stvaranje bakalara",
  "item.minecraft.cow_spawn_egg": "jaje za stvaranje krave",
  "item.minecraft.creeper_spawn_egg": "jaje za stvaranje creepera",
  "item.minecraft.dolphin_spawn_egg": "jaje za stvaranje dupina",
  "item.minecraft.donkey_spawn_egg": "jaje za stvaranje magarca",
  "item.minecraft.drowned_spawn_egg": "jaje za stvaranje utopljenika",
  "item.minecraft.elder_guardian_spawn_egg": "jaje za stvaranje drevnog čuvara",
  "item.minecraft.enderman_spawn_egg": "jaje za stvaranje endermana",
  "item.minecraft.endermite_spawn_egg": "jaje za stvaranje endermita",
  "item.minecraft.evoker_spawn_egg": "jaje za stvaranje prizivatelja",
  "item.minecraft.fox_spawn_egg": "jaje za stvaranje lisice",
  "item.minecraft.ghast_spawn_egg": "jaje za stvaranje ghasta",
  "item.minecraft.guardian_spawn_egg": "jaje za stvaranje čuvara",
  "item.minecraft.hoglin_spawn_egg": "jaje za stvaranje hoglina",
  "item.minecraft.horse_spawn_egg": "jaje za stvaranje konja",
  "item.minecraft.husk_spawn_egg": "jaje za stvaranje pustinjskog zombija",
  "item.minecraft.llama_spawn_egg": "jaje za stvaranje ljame",
  "item.minecraft.magma_cube_spawn_egg": "jaje za stvaranje magma kocke",
  "item.minecraft.mooshroom_spawn_egg": "jaje za stvaranje mooshrooma",
  "item.minecraft.mule_spawn_egg": "jaje za stvaranje mazge",
  "item.minecraft.ocelot_spawn_egg": "jaje za stvaranje ocelota",
  "item.minecraft.panda_spawn_egg": "jaje za stvaranje pande",
  "item.minecraft.parrot_spawn_egg": "jaje za stvaranje papige",
  "item.minecraft.phantom_spawn_egg": "jaje za stvaranje fantoma",
  "item.minecraft.pig_spawn_egg": "jaje za stvaranje svinje",
  "item.minecraft.piglin_spawn_egg": "jaje za stvaranje piglina",
  "item.minecraft.pillager_spawn_egg": "jaje za stvaranje razbojnika",
  "item.minecraft.polar_bear_spawn_egg": "jaje za stvaranje polarnog medvjeda",
  "item.minecraft.pufferfish_spawn_egg": "jaje za stvaranje napuhače",
  "item.minecraft.rabbit_spawn_egg": "jaje za stvaranje zeca",
  "item.minecraft.ravager_spawn_egg": "jaje za stvaranje razarača",
  "item.minecraft.salmon_spawn_egg": "jaje za stvaranje lososa",
  "item.minecraft.sheep_spawn_egg": "jaje za stvaranje ovce",
  "item.minecraft.shulker_spawn_egg": "jaje za stvaranje shulkera",
  "item.minecraft.silverfish_spawn_egg": "jaje za stvaranje srebrne ribice",
  "item.minecraft.skeleton_spawn_egg": "jaje za stvaranje kostura",
  "item.minecraft.skeleton_horse_spawn_egg": "jaje za stvaranje kosturskog konja",
  "item.minecraft.slime_spawn_egg": "jaje za stvaranje ljigavca",
  "item.minecraft.spider_spawn_egg": "jaje za stvaranje pauka",
  "item.minecraft.squid_spawn_egg": "jaje za stvaranje lignje",
  "item.minecraft.stray_spawn_egg": "jaje za stvaranje lutalice",
  "item.minecraft.strider_spawn_egg": "jaje za stvaranje paklenog šetača",
  "item.minecraft.trader_llama_spawn_egg": "jaje za stvaranje trgovčeve ljame",
  "item.minecraft.tropical_fish_spawn_egg": "jaje za stvaranje tropske ribe",
  "item.minecraft.turtle_spawn_egg": "jaje za stvaranje kornjače",
  "item.minecraft.vex_spawn_egg": "jaje za stvaranje dosađivača",
  "item.minecraft.villager_spawn_egg": "jaje za stvaranje seljanina",
  "item.minecraft.vindicator_spawn_egg": "jaje za stvaranje osvetnika",
  "item.minecraft.wandering_trader_spawn_egg": "jaje za stvaranje lutajućeg trgovca",
  "item.minecraft.witch_spawn_egg": "jaje za stvaranje vještice",
  "item.minecraft.wither_skeleton_spawn_egg": "jaje za stvaranje wither kostura",
  "item.minecraft.wolf_spawn_egg": "jaje za stvaranje vuka",
  "item.minecraft.zoglin_spawn_egg": "jaje za stvaranje zoglina",
  "item.minecraft.zombie_spawn_egg": "jaje za stvaranje zombija",
  "item.minecraft.zombie_horse_spawn_egg": "jaje za stvaranje zombi konja",
  "item.minecraft.zombie_villager_spawn_egg": "jaje za stvaranje zombi seljanina",
  "item.minecraft.zombified_piglin_spawn_egg": "jaje za stvaranje zombificiranog piglina",
  "item.minecraft.experience_bottle": "bočica čarolije",
  "item.minecraft.fire_charge": "vatrena kugla",
  "item.minecraft.writable_book": "knjiga i pero",
  "item.minecraft.written_book": "napisana knjiga",
  "item.minecraft.emerald": "smaragd",
  "item.minecraft.item_frame": "okvir",
  "block.minecraft.flower_pot": "lončanica",
  "item.minecraft.carrot": "mrkva",
  "item.minecraft.potato": "krumpir",
  "item.minecraft.baked_potato": "pečeni krumpir",
  "item.minecraft.poisonous_potato": "otrovni krumpir",
  "item.minecraft.map": "prazna karta",
  "item.minecraft.golden_carrot": "zlatna mrkva",
  "block.minecraft.skeleton_skull": "lubanja",
  "block.minecraft.wither_skeleton_skull": "lubanja wither kostura",
  "block.minecraft.player_head": "glava igrača",
  "block.minecraft.zombie_head": "glava zombija",
  "block.minecraft.creeper_head": "glava creepera",
  "block.minecraft.dragon_head": "glava zmaja",
  "item.minecraft.carrot_on_a_stick": "mrkva na štapu",
  "item.minecraft.warped_fungus_on_a_stick": "luda gljiva na štapu",
  "item.minecraft.nether_star": "nether zvijezda",
  "item.minecraft.pumpkin_pie": "pita od bundeve",
  "item.minecraft.firework_rocket": "vatrometna raketa",
  "item.minecraft.firework_star": "vatrometna zvijezda",
  "item.minecraft.enchanted_book": "začarana knjiga",
  "item.minecraft.nether_brick": "nether cigla",
  "item.minecraft.quartz": "nether kvarc",
  "item.minecraft.tnt_minecart": "vagon s tnt-om",
  "item.minecraft.hopper_minecart": "vagon s lijevkom",
  "item.minecraft.prismarine_shard": "krhotina prizmarina",
  "item.minecraft.prismarine_crystals": "kristali prizmarina",
  "item.minecraft.rabbit": "sirova zečetina",
  "item.minecraft.cooked_rabbit": "pečena zečetina",
  "item.minecraft.rabbit_stew": "gulaš od zeca",
  "item.minecraft.rabbit_foot": "zečja šapa",
  "item.minecraft.rabbit_hide": "zečja koža",
  "item.minecraft.armor_stand": "postolje za oklop",
  "item.minecraft.iron_horse_armor": "željezni konjski oklop",
  "item.minecraft.golden_horse_armor": "zlatni konjski oklop",
  "item.minecraft.diamond_horse_armor": "dijamantni konjski oklop",
  "item.minecraft.leather_horse_armor": "kožni konjski oklop",
  "item.minecraft.lead": "povodac",
  "item.minecraft.name_tag": "oznaka s imenom",
  "item.minecraft.command_block_minecart": "vagon s naredbenim blokom",
  "item.minecraft.mutton": "sirova janjetina",
  "item.minecraft.cooked_mutton": "pečena janjetina",
  "block.minecraft.white_banner": "bijela zastava",
  "block.minecraft.orange_banner": "narančasta zastava",
  "block.minecraft.magenta_banner": "roza zastava",
  "block.minecraft.light_blue_banner": "svjetloplava zastava",
  "block.minecraft.yellow_banner": "žuta zastava",
  "block.minecraft.lime_banner": "svjetlozelena zastava",
  "block.minecraft.pink_banner": "ružičasta zastava",
  "block.minecraft.gray_banner": "siva zastava",
  "block.minecraft.light_gray_banner": "svjetlosiva zastava",
  "block.minecraft.cyan_banner": "tirkizna zastava",
  "block.minecraft.purple_banner": "ljubičasta zastava",
  "block.minecraft.blue_banner": "plava zastava",
  "block.minecraft.brown_banner": "smeđa zastava",
  "block.minecraft.green_banner": "zelena zastava",
  "block.minecraft.red_banner": "crvena zastava",
  "block.minecraft.black_banner": "crna zastava",
  "item.minecraft.end_crystal": "end kristal",
  "item.minecraft.chorus_fruit": "voće chorusa",
  "item.minecraft.popped_chorus_fruit": "ispucano voće chorusa",
  "item.minecraft.beetroot": "cikla",
  "item.minecraft.beetroot_seeds": "sjemenke cikle",
  "item.minecraft.beetroot_soup": "juha od cikle",
  "item.minecraft.dragon_breath": "zmajev dah",
  "item.minecraft.splash_potion": "nestvoriv prskajući napitak□bez efekata",
  "item.minecraft.spectral_arrow": "spektralna strijela",
  "item.minecraft.tipped_arrow": "nestvoriva umočena strijela□bez efekata",
  "item.minecraft.lingering_potion": "dugotrajni nestvoriv napitak□bez efekata",
  "item.minecraft.shield": "štit",
  "item.minecraft.elytra": "elitre",
  "item.minecraft.spruce_boat": "čamac od smreke",
  "item.minecraft.birch_boat": "čamac od breze",
  "item.minecraft.jungle_boat": "čamac od prašumskog drva",
  "item.minecraft.acacia_boat": "čamac od akacije",
  "item.minecraft.dark_oak_boat": "čamac od tamnog hrasta",
  "item.minecraft.totem_of_undying": "totem besmrtnosti",
  "item.minecraft.shulker_shell": "shulkerova ljuska",
  "item.minecraft.iron_nugget": "grumen željeza",
  "item.minecraft.knowledge_book": "knjiga znanja",
  "item.minecraft.debug_stick": "štap otklanjanja grešaka",
  "item.minecraft.music_disc_13": "glazbeni disk□c418 - 13",
  "item.minecraft.music_disc_cat": "glazbeni disk□c418 - cat",
  "item.minecraft.music_disc_blocks": "glazbeni disk□c418 - blocks",
  "item.minecraft.music_disc_chirp": "glazbeni disk□c418 - chirp",
  "item.minecraft.music_disc_far": "glazbeni disk□c418 - far",
  "item.minecraft.music_disc_mall": "glazbeni disk□c418 - mall",
  "item.minecraft.music_disc_mellohi": "glazbeni disk□c418 - mellohi",
  "item.minecraft.music_disc_stal": "glazbeni disk□c418 - stal",
  "item.minecraft.music_disc_strad": "glazbeni disk□c418 - strad",
  "item.minecraft.music_disc_ward": "glazbeni disk□c418 - ward",
  "item.minecraft.music_disc_11": "glazbeni disk□c418 - 11",
  "item.minecraft.music_disc_wait": "glazbeni disk□c418 - wait",
  "item.minecraft.music_disc_pigstep": "glazbeni disk□lena raine – pigstep",
  "item.minecraft.trident": "trozubac□□kada je u glavnoj ruci:□+8 jačina napada□-2.9 brzina napada",
  "item.minecraft.phantom_membrane": "fantomska membrana",
  "item.minecraft.nautilus_shell": "ljuska nautilusa",
  "item.minecraft.heart_of_the_sea": "srce mora",
  "item.minecraft.crossbow": "samostrijel",
  "item.minecraft.suspicious_stew": "sumnjivi gulaš",
  "block.minecraft.loom": "tkalački stan",
  "item.minecraft.flower_banner_pattern": "uzorak zastave□lik cvijeta",
  "item.minecraft.creeper_banner_pattern": "uzorak zastave□lik creepera",
  "item.minecraft.skull_banner_pattern": "uzorak zastave□lik lubanje",
  "item.minecraft.mojang_banner_pattern": "uzorak zastave□stvar",
  "item.minecraft.globe_banner_pattern": "uzorak zastave□globus",
  "item.minecraft.piglin_banner_pattern": "uzorak zastave□lik njuške",
  "block.minecraft.composter": "komposter",
  "block.minecraft.barrel": "bačva",
  "block.minecraft.smoker": "pušnica",
  "block.minecraft.blast_furnace": "visoka peć",
  "block.minecraft.cartography_table": "stol za kartografiju",
  "block.minecraft.fletching_table": "stol za streljaštvo",
  "block.minecraft.grindstone": "brus",
  "block.minecraft.lectern": "pult",
  "block.minecraft.smithing_table": "stol za kovanje",
  "block.minecraft.stonecutter": "pila za rezanje kamena",
  "block.minecraft.bell": "zvono",
  "block.minecraft.lantern": "svjetiljka",
  "block.minecraft.soul_lantern": "živa svjetiljka",
  "item.minecraft.sweet_berries": "slatke bobice",
  "block.minecraft.campfire": "logorska vatra",
  "block.minecraft.soul_campfire": "logorska vatra živog plamena",
  "block.minecraft.shroomlight": "svjetlogljiva",
  "item.minecraft.honeycomb": "saće",
  "block.minecraft.bee_nest": "pčelinje gnijezdo",
  "block.minecraft.beehive": "košnica",
  "item.minecraft.honey_bottle": "bočica meda",
  "block.minecraft.honey_block": "blok meda",
  "block.minecraft.honeycomb_block": "blok saća",
  "block.minecraft.lodestone": "magnetit",
  "block.minecraft.netherite_block": "blok netherita",
  "block.minecraft.ancient_debris": "drevni ostaci",
  "block.minecraft.target": "meta",
  "block.minecraft.crying_obsidian": "plačući opsidijan",
  "block.minecraft.blackstone": "crni kamen",
  "block.minecraft.blackstone_slab": "ploča od crnog kamena",
  "block.minecraft.blackstone_stairs": "stube od crnog kamena",
  "block.minecraft.gilded_blackstone": "pozlaćeni crni kamen",
  "block.minecraft.polished_blackstone": "polirani crni kamen",
  "block.minecraft.polished_blackstone_slab": "polirana ploča od crnog kamena",
  "block.minecraft.polished_blackstone_stairs": "polirane stube od crnog kamena",
  "block.minecraft.chiseled_polished_blackstone": "isklesani polirani crni kamen",
  "block.minecraft.polished_blackstone_bricks": "polirane cigle crnog kamena",
  "block.minecraft.polished_blackstone_brick_slab": "polirana ploča od cigala crnog kamena",
  "block.minecraft.polished_blackstone_brick_stairs": "polirane stube od cigala crnog kamena",
  "block.minecraft.cracked_polished_blackstone_bricks": "oštećene polirane cigle crnog kamena",
  "block.minecraft.respawn_anchor": "oltar preporođenja",
}
export const hr_hr = items; 
